module.exports = __webpack_public_path__ + "/assets/fb.png";


/*****************
 ** WEBPACK FOOTER
 ** ../src/dash/front/styles/images/fb.png
 ** module id = 1062
 ** module chunks = 0
 **/